<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import { fade } from 'svelte/transition';
    import { fetchData, getLocalServer } from '../shared/utils/Data.svelte';
    import { sortByName, ignoreCaseSort } from '../shared/utils/Sort.svelte';
    import { addCircleOutline, settings, trash, link, bookmark, image, refresh, headset, videocam, document, download } from 'ionicons/icons/index.mjs';

    export let feature;
    export let session;
    let state = {}
    let media = {};

    const dispatch = createEventDispatcher();
    function sendMessage(message) {
      dispatch('message', message);
    }

    onMount(async () => {
        if (feature) {
            var path = "/v1/media/layer/" + feature.replace("_", "/");
            console.log(path);
            let [res, err]  = await fetchData(path, {
                headers: {
                    'Authorization': 'Bearer ' + session.token
                }
            });
            if (err) {
                console.log(err);
                return;
            }
          console.log(res.data.media);
          media = res.data.media;
        }
    });

    function openHandler(section) {
        state[section] = !state[section]
    }
</script>

<div id="stage" in:fade>
    {#if Object.keys(media).length > 0}
        {#if Object.keys(media).length == 1}
            {#each Object.keys(media) as section}
                <ul class="menu menu-nav">
                    {#if Object.values(media[section]).length > 0}
                        {#each Object.values(media[section]).sort(sortByName) as item}
                            <div class="tile tile-centered">
                                <div class="tile-content">
                                    <li class="menu-item">
                                        {#if item.type == "link" || item.type == "pdf"}
                                            <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                        {:else if item.type == "download"}
											{#if window.platform == "Windows"}
                                                <button class="btn btn-link" on:click|stopPropagation={async (e) => {
                                                    e.currentTarget.blur();
                                                    let [res, err]  = await fetchData(getLocalServer() + "/core", {
                                                        method: "POST",
                                                        headers: {
                                                                'Accept': 'application/json',
                                                                'Content-Type': 'application/json'
                                                        },
                                                        body: JSON.stringify({
                                                            url: item.uri
                                                        })
                                                    });
                                                    if (err || !res.found) {
                                                            window.open(item.uri, "_blank");
                                                    }
                                                }}>
                                                {item.name}
                                                </button>
                                            {:else}
                                                <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                            {/if}
                                        {:else}
                                            <button class="btn btn-link"
                                            on:click|stopPropagation={(e) => {
                                                e.currentTarget.blur();
                                                sendMessage({
                                                    type: "media",
                                                    data: {
                                                        type: item.type,
                                                        uri: item.uri
                                                    }
                                                })
                                            }}>{item.name}</button>
                                        {/if}
                                    </li>
                                    {#if item.description != ""}
                                        <small class="tile-title">{item.description}</small>
                                    {/if}
                                </div>
                                <div class="tile-action">
                                    <div class="type-icon">
                                        {#if item.type == "link"}
                                            <i class="svg">{@html link.md}</i>
                                        {:else if item.type == "download"}
											<i class="svg">{@html download.md}</i>
                                        {:else if item.type == "pdf" || item.type == "document"}
                                            <i class="svg">{@html bookmark.md}</i>
                                        {:else if item.type == "image"}
                                            <i class="svg">{@html image.md}</i>
                                        {:else if item.type == "360"}
                                            <i class="svg">{@html refresh.md}</i>
                                        {:else if item.type == "audio"}
                                            <i class="svg">{@html headset.md}</i>
                                        {:else if item.type == "video"}
                                            <i class="svg">{@html videocam.md}</i>
                                        {:else}
                                            <i class="svg">{@html document.md}</i>
                                        {/if}
                                    </div>
                                </div>
                            </div>
                        {/each}
                    {/if}
                </ul>
            {/each}
        {:else}
            {#each Object.keys(media).sort(ignoreCaseSort) as section}
                <div class="accordion" in:fade>
                    {#if state[section]}
                        <input type="checkbox" id={"group-" + section} on:change={(e) => {openHandler(section)}} name="accordion-checkbox" hidden checked>
                    {:else}
                        <input type="checkbox" id={"group-" + section} on:change={(e) => {openHandler(section)}} name="accordion-checkbox" hidden>
                    {/if}
                    <label class="accordion-header" for={"group-" + section}>
                        <div class="tile tile-centered">
                            <div class="tile-icon">
                                <div class="example-tile-icon">
                                  {#if state[section]}
                                      <i class="icon icon-arrow-down centered"></i>
                                  {:else}
                                      <i class="icon icon-arrow-right centered"></i>
                                  {/if}
                                </div>
                            </div>
                            <div class="tile-content">
                                <div class="tile-title">{section}</div>
                            </div>
                        </div>    
                    </label>
                    <div class="accordion-body">
                        <ul class="menu menu-nav">
                            {#if Object.values(media[section]).length > 0}
                                {#each Object.values(media[section]).sort(sortByName) as item}
                                    <div class="tile tile-centered">
                                        <div class="tile-content">
                                            <li class="menu-item">
                                                {#if item.type == "link" || item.type == "pdf"}
                                                    <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                                {:else if item.type == "download"}
													{#if window.platform == "Windows"}
                                                        <button class="btn btn-link" on:click|stopPropagation={async (e) => {
                                                            e.currentTarget.blur();
                                                            let [res, err]  = await fetchData(getLocalServer() + "/core", {
                                                                method: "POST",
                                                                headers: {
                                                                        'Accept': 'application/json',
                                                                        'Content-Type': 'application/json'
                                                                },
                                                                body: JSON.stringify({
                                                                    url: item.uri
                                                                })
                                                            });
                                                            if (err || !res.found) {
                                                                    window.open(item.uri, "_blank");
                                                            }
                                                        }}>
                                                        {item.name}
                                                        </button>
                                                    {:else}
                                                        <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                                    {/if}
                                                {:else}
                                                    <button class="btn btn-link"
                                                    on:click|stopPropagation={(e) => {
                                                        e.currentTarget.blur();
                                                        sendMessage({
                                                            type: "media",
                                                            data: {
                                                                type: item.type,
                                                                uri: item.uri
                                                            }
                                                        })
                                                    }}>{item.name}</button>
                                                {/if}
                                            </li>
                                            {#if item.description != ""}
                                                <small class="tile-title">{item.description}</small>
                                            {/if}
                                        </div>
                                        <div class="tile-action">
                                            <div class="type-icon">
                                                {#if item.type == "link"}
                                                    <i class="svg">{@html link.md}</i>
                                                {:else if item.type == "download"}
													<i class="svg">{@html download.md}</i>
                                                {:else if item.type == "pdf" || item.type == "document"}
                                                    <i class="svg">{@html bookmark.md}</i>
                                                {:else if item.type == "image"}
                                                    <i class="svg">{@html image.md}</i>
                                                {:else if item.type == "360"}
                                                    <i class="svg">{@html refresh.md}</i>
                                                {:else if item.type == "audio"}
                                                    <i class="svg">{@html headset.md}</i>
                                                {:else if item.type == "video"}
                                                    <i class="svg">{@html videocam.md}</i>
                                                {:else}
                                                    <i class="svg">{@html document.md}</i>
                                                {/if}
                                            </div>
                                        </div>
                                    </div>
                                {/each}
                            {/if}
                        </ul>
                    </div>
                </div>
            {/each}
        {/if}
    {:else}
        <div class="empty">
            <div class="empty-icon">
                <i class="svg">{@html image.md}</i>
            </div>
            <p class="empty-title h5">No media</p>
        </div>
    {/if}
</div>

<style>
    .accordion .accordion-header {
		cursor: pointer;
		user-select: none;
		height: 1rem;
		padding: 0.4rem;
	}
	.accordion-body {
		padding-left: 1rem;
        margin: 0.4rem 0 0 0;
    }
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
    .menu {
        padding: 0;
    }
    .menu .menu-item {
        padding: 0;
    }
	.menu-item  > a, .menu .menu-item > button {
        color: #00ab5f;
        border: 0;
        margin: 0;
        padding: 0.4rem 0.8rem;
        text-align: left;
	}
	.menu-item a:hover, .menu-item a:visited {
		background-color: transparent;
	}
	.menu .menu-item > a:focus, .menu .menu-item > a:hover {
		background-color: transparent;
    }
	.type-icon {
		display: inline-block;
		font-size: 0.8rem;
		height: 1.8rem;
		width: 1.8rem;
		line-height: 1.2rem;
		outline: none;
		padding: 0.4rem 0.4rem;
		text-align: center;
	}
    .empty .empty-icon {
        width: 150px;
        margin: auto;
    }
    .empty .empty-title {
        margin-top: 0;
        color: black;
    }
</style>